export class TipoMaterialDto {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly MostrarEnDashBoard: boolean,
    public Activo: boolean,
  ) {}
}

export class SaveTipoMaterialDto {
  constructor(
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly MostrarEnDashBoard: boolean,
    public readonly Activo: boolean,
  ) {}
}

export class SearchTipoMaterialRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly VerSoloActivos: boolean
  ) {}
}

export class SearchTipoMaterialResponse {
  constructor(
    public readonly count: number,
    public readonly result: TipoMaterialDto[]
  ) {}
}